import React from 'react';
import { Pencil as LucidePencil } from 'lucide-react';

interface PencilProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Pencil: React.FC<PencilProps> = ({ width = 24, height = 24, className, style }) => (
  <LucidePencil width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default Pencil;
